import './PendingChangesPanel.scss';
import { ReactNode } from 'react';
import { Header } from '../StickyTable';
import { displayValue, renderValue, RowType } from './pending-changes-utils';

interface PendingNewRowProps<R> {
  columns: Header[];
  newRow: R;
  pendingRowHeaderRender?: (row: R) => ReactNode;
}

export const PendingNewRow = <R extends RowType>({
  columns,
  newRow,
  pendingRowHeaderRender
}: PendingNewRowProps<R>) => (
  <div className='pending-changes-row-container pending-new-row-container'>
    {pendingRowHeaderRender && pendingRowHeaderRender(newRow) && (
      <div className='pending-changes-row-title'>{pendingRowHeaderRender(newRow)}</div>
    )}
    {columns.map(col => {
      const { label, field, renderer } = col;
      const newVal = displayValue(newRow[field ?? '']);
      return (
        <div key={label}>
          <div className='pending-changes-row'>
            <b className='pending-changes-row-label'>{label}:</b>
            <div>{renderer ? renderValue(renderer(newRow)) : newVal}</div>
          </div>
        </div>
      );
    })}
  </div>
);
